import { isValidBirthDate } from "@/utils/validators/isValidBirthDate";
import { isValidDocument } from "@/utils/validators/isValidDocument";
import { isValidEmail } from "@/utils/validators/isValidEmail";
import { isValidPassword } from "@/utils/validators/isValidPassword";
import { isValidPhoneNumber } from "@/utils/validators/isValidPhoneNumber";

export const signUpFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  phoneNumber: "",
  document: "",
  birthdate: "",
};

export function signUpFormValidator(value: typeof signUpFormValues) {
  return {
    firstName: !value.firstName && "Digite o primeiro nome",
    lastName: !value.lastName && "Digite o ultimo nome",
    birthdate: !isValidBirthDate(value.birthdate) && "Digite uma data valida",
    phoneNumber: !isValidPhoneNumber(value.phoneNumber) && "Telefone inválido",
    document: !isValidDocument(value.document) && "CPF inválido",
    email: !isValidEmail(value.email) && "Email inválido",
    password:
      !isValidPassword(value.password) &&
      "A senha deve ter mais de 8 caracteres, 1 letra maiuscula, 1 letra minuscula, 1 numero e 1 caractere especial (@ $ ! # % * ? & -)",
  };
}
